import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-label',
  templateUrl: './employee-label.component.html',
  styleUrls: ['./employee-label.component.scss']
})
export class EmployeeLabelComponent implements OnInit {
  @Input() employee: {
    id: number;
    firstName: string;
    lastName: string;
  }
  
  constructor() { }

  ngOnInit(): void {
  }

}
